import { render, staticRenderFns } from "./ConversationDetails.vue?vue&type=template&id=236ab2d4&scoped=true"
import script from "./ConversationDetails.vue?vue&type=script&lang=js"
export * from "./ConversationDetails.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Messagerie.css?vue&type=style&index=0&id=236ab2d4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236ab2d4",
  null
  
)

export default component.exports